import { FC, ReactNode } from 'react';
import { AuthContextProvider } from './authContext';

interface IAppContextProvider {
    children: ReactNode;
}

export const AppContextProvider: FC<IAppContextProvider> = ({ children }) => {
    return (
        <AuthContextProvider>
            {children}
        </AuthContextProvider>
    );
};
